/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProAlert } from '../../models/pro.model';

interface ProAlertsState {
  proAlertsLoading: boolean;
  proAlertsError: string | null;
  proAlerts: ProAlert[] | null;
}

export const INITIAL_PRO_ALERTS_STATE: ProAlertsState = {
  proAlertsLoading: false,
  proAlertsError: null,
  proAlerts: null,
};

const ProAlertsSlice = createSlice({
  name: 'proAlerts',
  initialState: INITIAL_PRO_ALERTS_STATE,
  reducers: {
    setProAlertsLoading: (state, action: PayloadAction<boolean>) => {
      state.proAlertsLoading = action.payload;
      state.proAlertsError = null;
      state.proAlerts = null;
    },
    setProAlertsError: (state, action: PayloadAction<string | null>) => {
      state.proAlertsError = action.payload;
      state.proAlertsLoading = false;
      state.proAlerts = null;
    },
    setProAlerts: (state, action: PayloadAction<ProAlert[] | null>) => {
      state.proAlerts = action.payload;
      state.proAlertsLoading = false;
      state.proAlertsError = null;
    },
    updateProAlert: (state, action) => {
      const { alertId, emails } = action.payload;
      if (!state.proAlerts) return;
      const alert = state.proAlerts.find((a) => a.alert_id === alertId);
      if (alert) {
        alert.emails = emails;
      }
    },
    addProAlert: (state, action: PayloadAction<ProAlert>) => {
      if (state.proAlerts) {
        state.proAlerts.push(action.payload);
      } else {
        state.proAlerts = [action.payload];
      }
    },
    removeProAlert: (state, action: PayloadAction<string>) => {
      if (state.proAlerts) {
        state.proAlerts = state.proAlerts.filter(
          (alert) => alert.alert_id !== action.payload
        );
      }
    },
  },
});

export const {
  setProAlertsLoading,
  setProAlertsError,
  setProAlerts,
  updateProAlert,
  addProAlert,
  removeProAlert,
} = ProAlertsSlice.actions;

export default ProAlertsSlice.reducer;
